import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { SmartSearchKeywordDirective } from 'mbs-ui-kit';
import { DisplayOsType, OSTypeAdapter } from 'mbs-ui-shared@models/Computer';
import { SmartSearchTemplateName } from 'mbs-ui-shared@modules/smart-search-templates/models/smart-search-templates-models';
import { getOsIcon } from 'mbs-ui-shared@utils/pipes/os-icon.pipe';
import { of } from 'rxjs';
import { SmartSearchBaseTemplateComponent } from '../base-template/smart-search-base-template.component';

@Component({
  selector: 'mbs-smart-search-os-template',
  templateUrl: '../base-template/smart-search-base-template.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  providers: [{ provide: SmartSearchKeywordDirective, useExisting: forwardRef(() => SmartSearchOsTemplateComponent) }]
})
export class SmartSearchOsTemplateComponent extends SmartSearchBaseTemplateComponent {
  public tag = SmartSearchTemplateName.OS;
  constructor(public i18nPipe: I18NextPipe) {
    super(i18nPipe);
  }
  public items = () =>
    of(
      [DisplayOsType.windows, DisplayOsType.linux, DisplayOsType.apple].map((value) => ({
        value,
        searchText: value,
        translation: `shared:computers.searchOSType:${value}`,
        icon: getOsIcon(OSTypeAdapter.find((osMap) => osMap.displayOS === value)?.os)
      }))
    );
}
